
import BaseDropdown from "@/components/base/BaseDropdown.vue";
import { titles } from "@/config/titles";
import { User, Customer } from "@/models/www/store/User";
import useVuelidate from "@vuelidate/core";
import { helpers, requiredIf } from '@vuelidate/validators';
import { UserType } from "@/models/enums";
import { defineComponent, PropType, reactive, ref } from "vue";
import AccountSetting from "./AccountSetting.vue";
import AccountSettingsSection from "./AccountSettingsSection.vue";
import { countryList } from "@/config/countries";
import BaseInput from "@/components/base/BaseInput.vue";
import useAccount from "@/composables/useAccount";
import BaseDateInput from "@/components/base/BaseDateInput.vue";

export default defineComponent({
	components: {
		AccountSettingsSection,
		AccountSetting,
		BaseDropdown,
		BaseInput,
		BaseDateInput,
	},
	props: {
		user: {
			type: Object as PropType<User>,
			required: true,
		},
	},
	setup(props) {
		const { updateCustomer } = useAccount();
		const loading = ref(false);
		const settingsSectionRef = ref();

		const state = reactive({
			title: (props.user as Customer)?.title,
			firstName: props.user.firstName,
			lastName: props.user.lastName,
			dateOfBirth: (props.user as Customer)?.dateOfBirth,
			address: props.user.address,
			city: props.user.city,
			zip: props.user.zip,
			countryCode: props.user.countryCode,
		});
	
		const rules = {
			title: {},
			firstName: {},
			lastName: {},
			dateOfBirth: { 
				required: helpers.withMessage('Format should be DD/MM/YYYY', requiredIf(() => props.user.type === UserType.Customer)),
		 	},
			address: {},
			city: {},
			zip: {},
			countryCode: {},
		};

		const v$ = useVuelidate(rules, state);

		const submit = async () => {
			const valid = await v$.value.$validate();
			if (valid) {
				loading.value = true;
				updateCustomer({ ...(props.user as Customer), ...state })
					.then(() => settingsSectionRef.value.toggle())
					.finally(() => (loading.value = false));
			}
		};

		return {
			v$,
			loading,
			submit,
			titles,
			countryList,
			settingsSectionRef,
			UserType,
		};
	},
});
